import useCasMutation, { IGenericMutationProps } from './useCasMutation';

type addMutationProps = IGenericMutationProps & {
  url: string;
};

export default function useAddMutation({ url, ...rest }: addMutationProps) {
  return useCasMutation({ method: 'post', url, ...rest });
}
